"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/card/style/css");

var _card = _interopRequireDefault(require("antd/es/card"));

var _faPlusCircle = require("@fortawesome/pro-solid-svg-icons/faPlusCircle");

var _button = _interopRequireDefault(require("antd/lib/button"));

var _tabs = _interopRequireDefault(require("antd/lib/tabs"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var _AntdIcon = _interopRequireDefault(require("../../../components/antdIcon/AntdIcon"));

var _ParticipantsByMonthBarChart = _interopRequireDefault(require("../../../components/charts/bar/ParticipantsByMonthBarChart"));

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  TabPane
} = _tabs.default;

class ArmsPage extends _react.Component {
  render() {
    const {
      study
    } = this.props;

    if (!study) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Error Loading Study");
    }

    const addArm = /*#__PURE__*/_react.default.createElement(_button.default, {
      disabled: true
    }, "Add Arm", /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
      fontAwesomeIcon: _faPlusCircle.faPlusCircle,
      classes: "fa-lg"
    })); // TODO use this array to populate the ArmTabPanes


    const arms = study.studyArms;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "arms-page"
    }, /*#__PURE__*/_react.default.createElement(_tabs.default, {
      defaultActiveKey: "arm-1",
      tabBarExtraContent: addArm
    }, /*#__PURE__*/_react.default.createElement(TabPane, {
      key: "arm-1",
      tab: "Control Group"
    }, /*#__PURE__*/_react.default.createElement(_card.default, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: '300px'
      }
    }, /*#__PURE__*/_react.default.createElement(_ParticipantsByMonthBarChart.default, {
      data: participantCounts
    })))), /*#__PURE__*/_react.default.createElement(TabPane, {
      key: "arm-2",
      tab: "Arm 1: No Referrals"
    }, /*#__PURE__*/_react.default.createElement(_card.default, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: '300px'
      }
    }, /*#__PURE__*/_react.default.createElement(_ParticipantsByMonthBarChart.default, {
      data: participantCounts
    })))), /*#__PURE__*/_react.default.createElement(TabPane, {
      key: "arm-3",
      tab: "Arm 2: Peer Referrals"
    }, /*#__PURE__*/_react.default.createElement(_card.default, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: '300px'
      }
    }, /*#__PURE__*/_react.default.createElement(_ParticipantsByMonthBarChart.default, {
      data: participantCounts
    }))))));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  study: selectors.getRequestedStudy
});
const participantCounts = [{
  month: 'JAN',
  Active: 72,
  ActiveColor: 'hsl(311, 70%, 50%)',
  Accepted: 5,
  AcceptedColor: 'hsl(33, 70%, 50%)',
  Dismissed: 0,
  DismissedColor: 'hsl(343, 70%, 50%)',
  Dropped: 1,
  DroppedColor: 'hsl(319, 70%, 50%)',
  Finished: 2,
  FinishedColor: 'hsl(276, 70%, 50%)'
}, {
  month: 'FEB',
  Active: 150,
  ActiveColor: 'hsl(311, 70%, 50%)',
  Accepted: 7,
  AcceptedColor: 'hsl(33, 70%, 50%)',
  Dismissed: 1,
  DismissedColor: 'hsl(343, 70%, 50%)',
  Dropped: 3,
  DroppedColor: 'hsl(319, 70%, 50%)',
  Finished: 15,
  FinishedColor: 'hsl(276, 70%, 50%)'
}, {
  month: 'MAR',
  Active: 203,
  ActiveColor: 'hsl(311, 70%, 50%)',
  Accepted: 4,
  AcceptedColor: 'hsl(33, 70%, 50%)',
  Dismissed: 0,
  DismissedColor: 'hsl(343, 70%, 50%)',
  Dropped: 2,
  DroppedColor: 'hsl(319, 70%, 50%)',
  Finished: 33,
  FinishedColor: 'hsl(276, 70%, 50%)'
}];

var _default = (0, _reactRedux.connect)(mapStateToProps)(ArmsPage);

exports.default = _default;